import AemComponent from '../AemComponent/AemComponent';
import EditableText from '../EditableText/EditableText';

const AemEditableText = (props) => {
    return <AemComponent component={EditableText} {...props} />;
};

export default AemEditableText;
